module.exports = __webpack_public_path__ + "static/music-player-bg-d3abe3fc5090efbb80e087a95288aad3.svg";